module.exports = __webpack_public_path__ + "img/o_illinois.6cf9f977.png";